import React, { useCallback } from "react";
import styles from "./journeyIncludeElements.module.css";
import ModalHeader from "common/ModalHeader";
import Button from "common/Button";
import CheckBox from "common/CheckBox";
import { groupedData } from "utils";

const JourneyIncludeElements = ({
  tickets,
  handleVariants,
  sidebarRef,
  type,
}) => {
  const handleVariantCheck = useCallback(
    (variant_index, ticket_index, checked) => {
      handleVariants({ variant_index, ticket_index, checked });
    },
    [handleVariants]
  );

  return (
    <div className={styles.bookingJourney} ref={sidebarRef}>
      <ModalHeader label="Included elements" />
      <form>
        <div className={styles.body}>
          {tickets?.map((ticket, ticket_index) => (
            // Use a combination of package_id/ticket_id and index for unique keys
            <div key={type === "package" ? 
              `package-${ticket.package_id}-${ticket_index}` : 
              `ticket-${ticket.ticket_id}-${ticket_index}`}
            >
              <div className={styles.elements}>
                <img src={ticket?.image_url} alt="ticket_Img" className={styles.elementsImg} />
                <div className={type === "package" ? styles.elementPackageBody : styles.elementBody}>
                  <div className={styles.name}>{type === "package" ? ticket.name : ticket.ticket_name}</div>
                  <div className={styles.name}>{ticket.element_description}</div>
                  <div className={styles.info}>{ticket.venue}</div>
                </div>
              </div>
              <div className={styles.addOns}>
                <div className={styles.addOnsLabel}>{type === "package" ? "" : "Select Variants"}</div>
                <div>
                  {type === "package" ? (
                    <div className={styles.addOnsCheckBox}>
                      <CheckBox
                        key={`package-checkbox-${ticket.package_id}-${ticket_index}`}
                        checked={ticket?.checked || false}
                        onClick={(e) =>
                          handleVariantCheck(0, ticket_index, e.target.checked)
                        }
                      />
                    </div>
                  ) : (
                    ticket?.variants?.map((variant, variant_index) => (
                      <CheckBox
                        key={`variant-${ticket.ticket_id}-${variant.variant_id}-${variant_index}`}
                        label={variant?.variant_name}
                        checked={variant.checked}
                        onClick={(e) =>
                          handleVariantCheck(variant_index, ticket_index, e.target.checked)
                        }
                      />
                    ))
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </form>
    </div>
  );
};

export default JourneyIncludeElements;
